import jolt65Img1 from "../assets/images/products/jolt-65-1.jpg";
import jolt65Img2 from "../assets/images/products/jolt-65-2.jpg";
import jolt65Img3 from "../assets/images/products/jolt-65-3.jpg";
import jolt65Img4 from "../assets/images/products/jolt-65-4.jpg";
import jolt65Img5 from "../assets/images/products/jolt-65-5.jpg";
import jolt65Img6 from "../assets/images/products/jolt-65-6.jpg";
import jolt65Img7 from "../assets/images/products/jolt-65-7.jpg";
import jolt100Img1 from "../assets/images/products/jolt-100-1.jpg";
import jolt100Img2 from "../assets/images/products/jolt-100-2.jpg";
import jolt100Img3 from "../assets/images/products/jolt-100-3.jpg";
import jolt100Img4 from "../assets/images/products/jolt-100-4.jpg";
import jolt100Img5 from "../assets/images/products/jolt-100-5.jpg";
import jolt100Img6 from "../assets/images/products/jolt-100-6.jpg";
import jolt100Img7 from "../assets/images/products/jolt-100-7.jpg";
import jolt100Img8 from "../assets/images/products/jolt-100-8.jpg";
import vintage45Img1 from "../assets/images/products/vintage45g-1.jpg";
import vintage45Img2 from "../assets/images/products/vintage45g-2.jpg";
import vintage45Img3 from "../assets/images/products/vintage45g-3.jpg";
import vintage45Img4 from "../assets/images/products/vintage45g-4.jpg";
import vintage45Img5 from "../assets/images/products/vintage45g-5.jpg";
import vintage65Img1 from "../assets/images/products/vintage65g-1.jpg";
import vintage65Img2 from "../assets/images/products/vintage65g-2.jpg";
import vintage65Img3 from "../assets/images/products/vintage65g-3.jpg";
import vintage65Img4 from "../assets/images/products/vintage65g-4.jpg";
import vintage65Img5 from "../assets/images/products/vintage65g-5.jpg";
import vintage65Img6 from "../assets/images/products/vintage65g-6.jpg";
import vintage100Img1 from "../assets/images/products/vintage100g-1.jpg";
import vintage100Img2 from "../assets/images/products/vintage100-2.jpg";
import vintage100Img3 from "../assets/images/products/vintage100-3.jpg";
import vintage100Img4 from "../assets/images/products/vintage100-4.jpg";
import vintage100Img5 from "../assets/images/products/vintage100-5.jpg";
import vintage100Img6 from "../assets/images/products/vintage100-6.jpg";
import vintage100Img7 from "../assets/images/products/vintage100-7.jpg";
import vintage100Img8 from "../assets/images/products/vintage100-8.jpg";

const JOLT_DESCRIPTION = `<p>Jolt is our signature blend of Instant Coffee and Chicory Mixture to elevate your daily coffee routine. With a harmonious blend of premium coffee and high-quality chicory, JOLT promises a unique and satisfying taste that's perfect for any occasion. It's a true indulgence for coffee lovers.</p>
<p>The chicory in our mixture complements the coffee perfectly, creating a smoother and less bitter taste. You'll love the balanced finish with every sip.</p>`;

const JOLT_65_IMAGES = [
  jolt65Img1,
  jolt65Img2,
  jolt65Img3,
  jolt65Img4,
  jolt65Img5,
  jolt65Img6,
  jolt65Img7,
];

const JOLT_100_IMAGES = [
  jolt100Img1,
  jolt100Img2,
  jolt100Img3,
  jolt100Img4,
  jolt100Img5,
  jolt100Img6,
  jolt100Img7,
  jolt100Img8,
];

const VINTAGE_DESCRIPTION = `<p>VINTAGE is our signature freeze-dried coffee, a medium roast blend, which is mild, aromatic, rich and smooth.</p>
<p>Experience this rich and aromatic flavor crafted with the finest Arabica coffee beans.</p>
<p>VINTAGE is crafted using 100% pure Arabica coffee beans known for their smooth, mellow, and rich flavor profile.</p>`;

const VINTAGE_45_IMAGES = [
  vintage45Img1,
  vintage45Img2,
  vintage45Img3,
  vintage45Img4,
  vintage45Img5,
];

const VINTAGE_65_IMAGES = [
  vintage65Img1,
  vintage65Img2,
  vintage65Img3,
  vintage65Img4,
  vintage65Img5,
  vintage65Img6,
];

const VINTAGE_100_IMAGES = [
  vintage100Img1,
  vintage100Img2,
  vintage100Img3,
  vintage100Img4,
  vintage100Img5,
  vintage100Img6,
  vintage100Img7,
  vintage100Img8,
];

export const INSTANT_COFFEE_PRODUCTS = {
  101: {
    _id: 101,
    id: 101,
    productName: "Vintage",
    variant: true,
    price: 0,
    images: VINTAGE_45_IMAGES,
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: VINTAGE_DESCRIPTION,
    productVariant: [
      {
        id: 1,
        name: "45g",
        price: 275,
        images: VINTAGE_45_IMAGES,
      },
      {
        id: 2,
        name: "65g",
        price: 399,
        images: VINTAGE_65_IMAGES,
      },
      {
        id: 3,
        name: "100g",
        price: 599,
        images: VINTAGE_100_IMAGES,
      },
    ],
  },
  102: {
    _id: 102,
    id: 102,
    productName: "Jolt",
    variant: true,
    price: 0,
    images: JOLT_65_IMAGES,
    stock: 50,
    numOfReviews: 0,
    comingSoon: false,
    productDescription: JOLT_DESCRIPTION,
    productVariant: [
      {
        id: 1,
        name: "65g",
        price: 225,
        images: JOLT_65_IMAGES,
      },
      {
        id: 2,
        name: "100g",
        price: 325,
        images: JOLT_100_IMAGES,
      },
    ],
  },
};

export function getInstantCoffeeProduct(id) {
  return INSTANT_COFFEE_PRODUCTS[id];
}
